<template>
    <div class="bs-table-table">
      <v-row no-gutters>
        <v-col class="col-without-top-padding table-color">
          <v-data-table
            class="bs-table elevation-0"
            calculate-widths
            :items="employees"
            :headers="tableHeader"
            :options.sync="options"
            :page.sync="page"
            :loading="employeesLoading"
            :server-items-length="totalPassengers"
            :multi-sort="false"
            :must-sort="true"
            :single-expand="true"
            hide-default-footer
            @page-count="pageCount = $event"
          >
            <template v-slot:item.createdAt="{ item }">
              {{ formatDate(item.createdAt) }}
            </template>

            <template v-slot:item.givenName="{ item }">
              {{ item.givenName }} {{ item.familyName }}
            </template>

            <template v-slot:item.role="{}">
              {{ $t(`components.employeeList.tabs.passenger`) }}
            </template>

            <template v-slot:item.email="{ item }">
              {{ item.email }}
            </template>

            <template v-slot:item.group="{ item }">
              <span v-if="item.businessPassengerGroups.length > 0">
                {{ item.businessPassengerGroups.map((el) => el.name).join(', ') }}
              </span>
            </template>

            <template v-slot:item.passenger.phoneNumber="{ item }">
              {{ item.passenger.phoneNumber }}
            </template>

            <template v-slot:item.actions="{ item }">
              <v-tooltip v-if="selectedTab === 'employee'" bottom>
                <template v-slot:activator="{ on, attrs }">
                  <email-icon v-on="on" v-bind="attrs" @click="resendEmailInvitation(item)" class="mr-1 icon-control-list"/>
                </template>
                <span>{{ $t(`components.employeeList.tooltips.${selectedTab}.resendMail`) }}</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <edit-icon @click="editEmployeeClick(item)" v-on="on" v-bind="attrs" class="mr-1 icon-control-list"/>
                </template>
                <span>{{ $t(`components.employeeList.tooltips.${selectedTab}.editEmployee`) }}</span>
              </v-tooltip>
              <v-tooltip bottom >
                <template v-slot:activator="{ on, attrs }">
                  <delete-icon @click="deleteEmployeeClick(item)" v-on="on" v-bind="attrs" class="mr-1 icon-control-list"/>
                </template>
                <span>{{ $t(`components.employeeList.tooltips.${selectedTab}.deleteEmployee`) }}</span>
              </v-tooltip>
            </template>
          </v-data-table>
          <div class="d-flex justify-between align-center py-2 px-4 bs-table-footer">
            <v-row no-gutters class="bs-per-page">
              <span>
                {{ $t(`global.perPage`) }}
              </span>
              <span
                v-for="item  in [10, 20, 30]"
                :key="item"
                class="px-1"
                :class="{ 'active-page-count': item === options.itemsPerPage }"
                @click="options.itemsPerPage = item"
              >
                {{ item }}
              </span>
            </v-row>
            <v-pagination
              v-model="page"
              :length="pageCount"
              :total-visible="7"
              color="#f2f2f2"
              class="bs-pagination"
            ></v-pagination>
          </div>
        </v-col>
      </v-row>
    </div>
</template>

<script>
import { longDateTime } from '@/helpers/dateTime';
import { iconLoader } from '@/helpers/iconsLoader';

export default {
  name: 'EmployeeList',
  components: {
    ...iconLoader.elements,
  },
  props: {
    employees: {
      type: Array,
      default: () => [],
    },
    employeesLoading: {
      type: Boolean,
      default: false,
    },
    totalPassengers: {
      type: Number,
      default: 0,
    },
    tableHeader: {
      type: Array,
      default: () => [],
    },
    selectedTab: {
      type: String,
      default: 'employee',
    },
  },
  data() {
    return {
      options: {},
      page: 1,
      pageCount: 0,
    };
  },
  watch: {
    options: {
      handler() {
        this.$emit('options', this.options);
      },
      deep: true,
    },
    selectedTab(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.page = 1;
        this.options.itemsPerPage = 10;
      }
    },
  },
  methods: {
    formatDate(date) {
      return longDateTime(date);
    },
    deleteEmployeeClick(item) {
      this.$emit('deleteEmployeeClick', item);
    },
    async resendEmailInvitation(item) {
      this.$emit('resendEmailClick', item);
    },
    editEmployeeClick(item) {
      this.$emit('editEmployeeClick', item);
    },
  },
};
</script>

<style lang="scss">
.passenger-status {
  color: #47d061 !important;
  font-weight: 400;
  font-size: 13px;
  text-transform: capitalize;
}
</style>
